import React, { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  FaChevronLeft,
  FaChevronRight,
  FaRegCopy,
  FaTimes,
} from "react-icons/fa";
import { PortfolioProject } from "../../../../../../../graphql/generated";
import {
  ProjectDetailsModalBody,
  ProjectDetailsModalContainer,
  ProjectDetailsModalFooter,
  ProjectDetailsModalHeader,
  ProjectDetailsModalWrapper,
} from "./styled";

interface Props {
  showModal: boolean;
  closeModal: () => void;
  currentProject: PortfolioProject | null;
  onPrevClick: () => void;
  onNextClick: () => void;
}

const ProjectDetailsModal: React.FC<Props> = ({
  showModal,
  closeModal,
  currentProject,
  onPrevClick,
  onNextClick,
}) => {
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopied(null);
    }, 1000);

    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <ProjectDetailsModalWrapper
      show={showModal ? 1 : 0}
      onClick={() => closeModal()}
    >
      <ProjectDetailsModalContainer onClick={(e) => e.stopPropagation()}>
        <ProjectDetailsModalHeader>
          <h1>{currentProject?.name || "Project Title"}</h1>

          <FaTimes onClick={() => closeModal()} />
        </ProjectDetailsModalHeader>

        <ProjectDetailsModalBody>
          <h3>Project Image : </h3>
          <img
            src={currentProject?.images?.thumbnailImg || "/images/bg.jpg"}
            alt={currentProject?.name || "Project Title"}
          />

          <h3>Project Title : </h3>
          <p>{currentProject?.name || "Project Title"}.</p>

          <h3>Project Description : </h3>
          <p>{currentProject?.description || "Project Description"}.</p>

          <h3>Project Links : </h3>
          <span>
            <CopyToClipboard
              onCopy={() => {
                setCopied("website");
              }}
              text={currentProject?.demo || "https://"}
            >
              <FaRegCopy />
            </CopyToClipboard>
            {currentProject?.demo && currentProject?.demo.length > 45
              ? currentProject?.demo
              : currentProject?.demo.substr(0, 45) || "https://"}
            <span
              {...(copied === "website"
                ? { style: { opacity: "1", visibility: "visible" } }
                : {})}
            >
              COPIED!
            </span>
          </span>
          <span>
            <CopyToClipboard
              onCopy={() => {
                setCopied("github");
              }}
              text={currentProject?.github || "https://"}
            >
              <FaRegCopy />
            </CopyToClipboard>
            {currentProject?.github && currentProject?.github.length > 45
              ? currentProject?.github
              : currentProject?.github.substr(0, 45) || "https://"}
            <span
              {...(copied === "github"
                ? { style: { opacity: "1", visibility: "visible" } }
                : {})}
            >
              COPIED!
            </span>
          </span>

          {currentProject?.tags?.length && (
            <>
              <h3>Used Technologies : </h3>
              <div>
                {currentProject?.tags?.map?.((item, i) => (
                  <span key={i}>{item}</span>
                ))}
              </div>
            </>
          )}
        </ProjectDetailsModalBody>

        <ProjectDetailsModalFooter>
          <FaChevronLeft onClick={onPrevClick} />
          <FaChevronRight onClick={onNextClick} />
        </ProjectDetailsModalFooter>
      </ProjectDetailsModalContainer>
    </ProjectDetailsModalWrapper>
  );
};

export default ProjectDetailsModal;
